// Payment-method registry helpers — the backend registry (/api/payment-methods/meta) is the
// source of truth; these render the dynamic per-method fields in forms and read views.
export const METHOD_ORDER = ["paypal", "revolut", "wise", "bank", "crypto", "other"];

export const METHOD_LABELS = {
  paypal: "PayPal",
  revolut: "Revolut",
  wise: "Wise",
  bank: "Bank Transfer",
  crypto: "Crypto",
  other: "Other",
};

export const methodLabel = (m) => METHOD_LABELS[m] || m || "—";

// Renders saved slot fields as label: value rows (read views).
export const slotRows = (slot, methods) => {
  if (!slot?.method || !methods?.[slot.method]) return [];
  return methods[slot.method].fields
    .map((f) => ({ label: f.label.replace(/\s*\(optional\)\s*/i, ""), value: (slot.fields || {})[f.key] || "", required: f.required }))
    .filter((r) => r.value || r.required);
};

export const slotComplete = (slot, methods) => {
  if (!slot?.method || !methods?.[slot.method]) return false;
  return methods[slot.method].fields.filter((f) => f.required).every((f) => (slot.fields || {})[f.key]);
};
